import { render, staticRenderFns } from "./anagraficaStudente.vue?vue&type=template&id=64e8b32d&"
import script from "./anagraficaStudente.vue?vue&type=script&lang=js&"
export * from "./anagraficaStudente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports